export const portfolioApi = process.env.VUE_APP_PORTFOLIO_SERVICE_URL
export const ipApi = process.env.VUE_APP_IP_SERVICE_URL;
